import { useState, useEffect } from "react";
import api from "../api";

const CALL_TYPES = ["Enquiry","Sales","Support","Complaint","Other"];

export default function DirectCall() {
  const [calls, setCalls] = useState([]);
  const [form, setForm] = useState({caller_name:"",caller_phone:"",call_type:"Enquiry",notes:""});
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.get("/portal/direct_calls").then(d => setCalls(d.items||[])).catch(()=>{});
  }, []);

  const submit = async e => {
    e.preventDefault();
    if (!form.caller_name) { setMsg("Caller name required."); return; }
    try {
      await api.post("/portal/direct_call", form);
      setMsg("✓ Logged");
      setForm({caller_name:"",caller_phone:"",call_type:"Enquiry",notes:""});
      const d = await api.get("/portal/direct_calls");
      setCalls(d.items||[]);
    } catch(e) { setMsg(e.message); }
  };

  return (
    <div>
      <h2 className="page-title">Direct Call Log</h2>
      <p className="page-sub">Log walk-in visitors or phone enquiries</p>
      <div className="card" style={{marginTop:16,marginBottom:20}}>
        <form onSubmit={submit} style={{display:"grid",gap:12}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <div><label>Caller Name *</label><input className="inp" value={form.caller_name} onChange={e=>setForm({...form,caller_name:e.target.value})} placeholder="Full name"/></div>
            <div><label>Phone</label><input className="inp" value={form.caller_phone} onChange={e=>setForm({...form,caller_phone:e.target.value})} placeholder="+91 XXXXX XXXXX"/></div>
          </div>
          <div><label>Call Type</label>
            <select className="inp" value={form.call_type} onChange={e=>setForm({...form,call_type:e.target.value})}>
              {CALL_TYPES.map(t=><option key={t}>{t}</option>)}
            </select>
          </div>
          <div><label>Notes</label><textarea className="inp" rows={3} value={form.notes} onChange={e=>setForm({...form,notes:e.target.value})} placeholder="Any additional notes…"/></div>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            <button className="btn" type="submit">Log Call</button>
            {msg && <span style={{fontSize:13,color:msg.startsWith("✓")?"var(--ok)":"var(--danger)"}}>{msg}</span>}
          </div>
        </form>
      </div>
      <div className="card">
        <table className="tbl">
          <thead><tr><th>Time</th><th>Caller</th><th>Phone</th><th>Type</th><th>Notes</th></tr></thead>
          <tbody>
            {calls.map((c,i)=>(
              <tr key={i}>
                <td style={{fontSize:12,color:"var(--muted)",whiteSpace:"nowrap"}}>{c.time}</td>
                <td><b>{c.caller_name}</b></td><td>{c.caller_phone||"—"}</td>
                <td><span className="pill gray">{c.call_type}</span></td>
                <td style={{maxWidth:200,overflow:"hidden",textOverflow:"ellipsis"}}>{c.notes||"—"}</td>
              </tr>
            ))}
            {!calls.length && <tr><td colSpan={5} style={{textAlign:"center",color:"var(--muted)"}}>No calls logged yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
